require('intersection-observer');
import { each, some } from 'lodash';

// https://developers.google.com/web/updates/2016/04/intersectionobserver
const _observeItem = function ({ element, threshold = 0.5, callback }) {
    // "10% visible for more than a continuous second"

    const isVisible = function (boundingClientRect, intersectionRect) {
        return (
            (intersectionRect.width * intersectionRect.height) /
                (boundingClientRect.width * boundingClientRect.height) >=
            threshold
        );
    };

    const visibleTimerCallback = function (element, observer) {
        delete element.visibleTimeout;
        // Process any pending observations
        processChanges(observer.takeRecords());
        if ('isVisible' in element) {
            delete element.isVisible;
            observer.unobserve(element);
        }
    };

    function processChanges(changes) {
        each(changes, function (changeRecord) {
            var element = changeRecord.target;
            element.isVisible = isVisible(
                changeRecord.boundingClientRect,
                changeRecord.intersectionRect
            );
            if (element.isVisible) {
                // Transitioned from hidden to visible
                //   console.log("Became visibile");
                callback(element);
                element.visibleTimeout = setTimeout(
                    visibleTimerCallback,
                    1000,
                    element,
                    observer
                );
            } else {
                // Transitioned from visible to hidden
                //   console.log("invisible");
                if ('visibleTimeout' in element) {
                    clearTimeout(element.visibleTimeout);
                    delete element.visibleTimeout;
                }
            }
        });
    }

    var observer = new IntersectionObserver(processChanges, {
        threshold: [threshold],
    });

    observer.observe(element);
};

const _observeItems = ({ items, imageIdentifier, sourceAttribute, cb }) => {
    each(items, (item) => {
        const itm = item;
        const imagesToLazyLoad = itm.getElementsByClassName(imageIdentifier);

        each(imagesToLazyLoad, (imageToLazyLoad) => {
            if (imageToLazyLoad !== undefined) {
                const url =
                    imageToLazyLoad.getAttribute(sourceAttribute) ||
                    imageToLazyLoad.getAttribute('data-src');
                const shouldLazyLoad =
                    (url !== '' &&
                        url !== null &&
                        url !== undefined &&
                        imageToLazyLoad.isSrcAlreadySet === undefined) ||
                    imageToLazyLoad.getAttribute('data-src') !==
                        imageToLazyLoad.getAttribute('src');

                _observeItem({
                    element: itm,
                    threshold: 0.1,
                    callback: function () {
                        imageToLazyLoad.isSrcAlreadySet =
                            imageToLazyLoad.getAttribute('data-src') ===
                            imageToLazyLoad.getAttribute('src');
                        if (shouldLazyLoad) {
                            if (!imageToLazyLoad.isSrcAlreadySet) {
                                imageToLazyLoad.setAttribute('src', url);

                                if (cb) {
                                    cb(imageToLazyLoad);
                                }
                                imageToLazyLoad.isSrcAlreadySet =
                                    imageToLazyLoad.getAttribute('data-src') ===
                                    imageToLazyLoad.getAttribute('src');
                                imageToLazyLoad.classList.add(
                                    'image-lazyloaded'
                                );
                            }
                        }
                    },
                });
            }
        });
    });
};

const setIntervalX = function (callback, delay, repetitions) {
    var x = 0;
    var intervalID = window.setInterval(function () {
        callback();

        if (++x === repetitions) {
            window.clearInterval(intervalID);
        }
    }, delay);
    return intervalID;
};

const observeArticleImages = () => {
    // Per ogni .article__image visibile per almeno 10% della superficie,
    // richiedo al server la immagine.
    // Se l'utente ha in viewport l'immagine per + di 1 secondo, non la richiedo più
    // e sgancio l'observer
    var intervalTryId = setIntervalX(
        function () {
            var items = document.getElementsByClassName('article');
            if (items && items.length > 0) {
                _observeItems({
                    items: items,
                    imageIdentifier: 'article__image',
                });
                window.clearInterval(intervalTryId);
            }
        },
        //1000,
        300,
        8
    );
};

const observeBannerImages = () => {
    var items = document.getElementsByClassName('banner__link');

    each(items, (item) => {
        const itm = item;
        const sourcesToLazyLoad = itm.getElementsByTagName('source');
        const imageToLazyLoad = itm.getElementsByClassName('banner__img')[0];

        if (imageToLazyLoad !== undefined) {
            const url = imageToLazyLoad.getAttribute('data-src') || '';
            const shouldLazyLoad =
                url !== '' &&
                some(
                    sourcesToLazyLoad,
                    (s) => (s.getAttribute('data-srcset') || '') !== ''
                );

            _observeItem({
                element: itm,
                threshold: 0.1,
                callback: function () {
                    if (shouldLazyLoad) {
                        if (!imageToLazyLoad.isSrcAlreadySet) {
                            each(sourcesToLazyLoad, (s) => {
                                const srcset =
                                    s.getAttribute('data-srcset') || '';
                                s.setAttribute('srcset', srcset);
                            });

                            imageToLazyLoad.setAttribute('src', url);
                            imageToLazyLoad.isSrcAlreadySet = true;
                            imageToLazyLoad.classList.add('image-lazyloaded');
                        }
                    }
                },
            });
        }
    });
};

export default {
    observeArticleImages,
    observeBannerImages,
    observeReviewGallery: function ({ element, cb }) {
        if (element) {
            _observeItem({
                element,
                callback: (imageToLazyLoad) => {
                    if (imageToLazyLoad) {
                        return cb(imageToLazyLoad);
                    }
                    return undefined;
                },
            });
        }
        return undefined;
    },
    observeQuestionGallery: function ({ element, cb }) {
        if (element) {
            _observeItem({
                element,
                callback: (imageToLazyLoad) => {
                    if (imageToLazyLoad) {
                        return cb(imageToLazyLoad);
                    }
                    return undefined;
                },
            });
        }
        return undefined;
    },
};
